function SaleReportPage() {
  return <></>;
}
export default SaleReportPage;
